export const storeJwt = (jwt: string) => {
  localStorage.setItem("access_token", jwt);
};
